<div id="container">
    <div id="content">
        <div id="headerContainer">
            <h4 class="mainDarkBlueText normalFontWeight">
                {{ "ALERTS_PER_HOUR" | translate }}
            </h4>
            <statistics-png-download-btn [widget]="this" />
        </div>

        <div id="chartContainer">
            <canvas #chartCanvas height="290"></canvas>
        </div>
    </div>
</div>
